import { useState } from 'react';
import { primaryNav } from '@/constants/siteNav';
import LegalModal, { type LegalType } from '@/components/feature/LegalModal';

const socials = [
  { icon: 'ri-instagram-line', label: 'Instagram' },
  { icon: 'ri-wechat-line', label: 'WeChat' },
  { icon: 'ri-mail-line', label: 'Email' },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const [legal, setLegal] = useState<LegalType | null>(null);

  return (
    <footer className="bg-accent-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-6">
            <p className="font-heading text-2xl tracking-[0.3em] text-foreground-950">NOMOISM</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              从中国美食出发，进入东方风土，回应当代人的愿望。
              <br />
              一味 × 一境 × 一愿，创造属于当代人的东方潮玩。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href="mailto:info@mizean.com"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/70 text-foreground-700 transition-colors duration-300 hover:text-primary-600 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3 md:justify-self-center">
            <p className="text-[11px] tracking-[0.24em] text-foreground-500 uppercase">Explore</p>
            <ul className="mt-5 space-y-3">
              {primaryNav.map((item) => (
                <li key={item.key}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-700 transition-colors duration-300 hover:text-primary-600 cursor-pointer"
                  >
                    {item.zh} · {item.en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3 md:justify-self-end md:text-right">
            <p className="text-[11px] tracking-[0.24em] text-foreground-500 uppercase">Made in</p>
            <p className="mt-5 text-sm text-foreground-700">杭州 · 中国</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-accent-200/80 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © {year} NOMOISM. 一味一世界，一境一故事，一愿一生活。
          </p>
          <div className="flex flex-wrap items-center gap-5">
            <button
              type="button"
              onClick={() => setLegal('privacy')}
              className="text-xs text-foreground-600 transition-colors duration-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              隐私政策
            </button>
            <button
              type="button"
              onClick={() => setLegal('terms')}
              className="text-xs text-foreground-600 transition-colors duration-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              使用条款
            </button>
            <button
              type="button"
              onClick={() => setLegal('children')}
              className="text-xs text-foreground-600 transition-colors duration-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              儿童个人信息保护规则
            </button>
          </div>
        </div>
      </div>

      <LegalModal active={legal} onClose={() => setLegal(null)} />
    </footer>
  );
}